import { PureComponent } from 'react'
import { Icon, List } from 'semantic-ui-react'

import { Emoji } from 'images'

import Message from '../modals/Message'

import './ColorConventions.css'

class ColorConventions extends PureComponent {
  state = {
    action: null,
  }

  onCloseMessage = () => {
    this.setState({
      action: null,
    })
  }

  showDetails = () => {
    const message = (
      <div className="ColorConventions__details">
        En <b>SweatBits</b>
        <br /> cada color tiene un significado.
        <br />
        <List>
          <List.Item>
            <Icon color="grey" name="circle" />
            <List.Content>
              Encuentro no iniciado.
              <br />
              no programado o pospuesto.
              <br />
              <small> - Hay que esperar.</small>
              <br />
            </List.Content>
          </List.Item>
          <List.Item>
            <Icon color="yellow" name="circle" />
            <List.Content>
              Encuentro en juego.
              <br />
              Puedes <b>cambiar el marcador</b> y <b>reportar eventos.</b>
              <br />
              <small> - Algo está pasando.</small>
              <br />
            </List.Content>
          </List.Item>
          <List.Item>
            <Icon color="green" name="circle" />
            <List.Content>
              Encuentro terminado.
              <br />
              Puedes <b>cambiar el marcador</b> y <b>reportar eventos.</b>
              <br />
              <small> - Algo se puede hacer.</small>
              <br />
            </List.Content>
          </List.Item>
          <List.Item>
            <Icon color="black" name="circle" />
            <List.Content>
              Encuentro aprobado.
              <br />
              La <b>institución aprobó</b> el encuentro.
              <br />
              <small> - Ya ni modo, lo que fue, fue.</small>
              <br />
            </List.Content>
          </List.Item>
          <List.Item>
            <Icon color="red" name="circle" />
            <List.Content>
              Algo anda mal.
              <br />
              <small> - Esperamos no ver este color.</small>
              <br />
            </List.Content>
          </List.Item>
        </List>
      </div>
    )

    const options = [
      {
        content: 'Continuar',
        onClick: this.onCloseMessage,
        primary: true,
      },
    ]
    this.setState({
      action: <Message message={message} onClose={this.onCloseMessage} options={options} show />,
    })
  }

  render() {
    const { action } = this.state

    return (
      <span
        className="ColorConventions"
        onClick={action ? null : this.showDetails}
        onKeyPress={this.showDetails}
        role="button"
        tabIndex={-1}
      >
        {action} <b className="color-fade">0 ~ 0</b> <Emoji className="text-xl" name="face_with_raised_eyebrow" />{' '}
        ¡Descubre qué son los colores! <Emoji className="text-xl" name="thinking_face" />
      </span>
    )
  }
}

export default ColorConventions
